import React, { Component } from "react";
import { Cuvette } from "@learningblocks/storybook-components";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { css } from "glamor";
import Toast from "../../../../Dialogs/toast/Toast";
import {HamburgerIcon} from "@learningblocks/storybook-components/lib/Icons";

// Styles
import colors from "@learningblocks/protocol-constants/lib/Styles/_exports.module.scss";


const toasterNotify = (type, msg, title) => {
    let color = "";
    if (type === "HINT") {
      color = colors.yellow1;
    } else {
      color = colors.red1;
    }

    toast(<Toast type={type} msg={msg} title={title} />, {
      className: css({
        border: "2px solid " + color,
        borderRadius: "6px",
        marginLeft: "-200px",
        minWidth: "400px"
      }),
      progressClassName: css({
        background: color
      }),
      position: "top-center",
      autoClose: 5000
    });
};

export const NOTIFY_EVENTS = {
  NOT_RUNNABLE: {
    title: "Microcentrifuge open or not balanced!",
    message: "Ensure that the tubes are balanced and the lid of centrifuge is closed."
  },
  BALANCED: {
    title: "Balanced!",
    message: "Looks balanced."
  },
  NOT_BALANCED: {
    title: "Not balanced!",
    message: "Distribute the tubes evently to balance the centrifuge."
  },
  NOT_ALLOWED_CENTRIFUGE_RUNNING: {
    title: "Centrifuge running!",
    message: "Operation not avaliable while centrifuge running."
  },
};

export class Graphics extends Component {
  constructor(props){
    super(props)
  }
  
  removeItemFromCuvette = () => {
    if(this.props.lidId >= 0){

      this.props.setCuvetteSealsInScene({
        id: this.props.lidId,
        inScene: true
      })

      this.props.onRemoveItem({
        id: this.props.id,
        type: "lid"
      });
    }else if(this.props.solution != null){
      this.props.onRemoveItem({
        id: this.props.id,
        type: "solution"
      });
    }
  }

  getSolutionColor = (solutions) => {

    if(solutions !== null && typeof solutions !== 'undefined'){
      let pH = 0;
      //let volume = 0;

      for(var sol in solutions){
        //volume =+ solutions[sol].volume;
        pH =+ solutions[sol].pH;
      }

      pH = pH / Object.keys(solutions).length;

      let pHLookup = {
        "-1": 'red',
        "2": "rgb(246, 205, 15)",
        "6": "rgb(209, 185, 61)",
        "6.1": "rgb(212, 184, 41)",
        "6.3": "rgb(194, 184, 48)",
        "6.5": "rgb(154, 173, 58)",
        "6.7": "rgb(119, 145, 59)",
        "6.9": "rgb(85, 119, 54)",
        "7.1": "rgb(48, 89, 60)",
        "7.3": "rgb(1, 61, 70)",
        "7.5": "rgb(23, 35, 77)",
        "7.7": "rgb(26, 37, 83)",
        "7.9": "rgb(32, 39, 91)",
        "8.0": "rgb(3, 31, 92)",
        "12": "rgb(43, 45, 123)"
      }

      let match = Object.keys(pHLookup).reduce((a, b) => {
        return Math.abs(parseFloat(b) - parseFloat(pH)) < Math.abs(parseFloat(a) - parseFloat(pH)) ? b : a;
      })

      if(Object.keys(solutions).includes('BTB')){
        return pHLookup[match];
      } else {
        return "#66cef5"
      }
    }

  }

  showMoveMenu(){
    this.props.setMoveMenu({
      component: "cuvette",
      type: this.props.type,
      connect: this.props.id
    });
    this.props.showMoveMenu({ display: !this.props.moveMenuDisplay });
  };

  render() {
    return (
      <Cuvette
        id={this.props.id}
        solution={this.getSolutionColor(this.props.solution)}
        lidId={this.props.lidId}
        tooltipLabel={this.props.tooltipLabel}
        onRemoveItem={() => this.removeItemFromCuvette()}
        buttonList={[{image: HamburgerIcon, onClick: ()=>{this.showMoveMenu()} }]}
        hideControls={this.props.hideControls}
        alert={(event) => toasterNotify("WARNING", NOTIFY_EVENTS[event].message, NOTIFY_EVENTS[event].title)}
      />
    );
  }
}
